var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pt-distribute-task',{staticClass:"pt-distribute-task__withData"})
}
var staticRenderFns = []

export { render, staticRenderFns }